/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockSharedItems
 */
angular.module('mercury.modules.stock.item')
.factory('StockSharedItems', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var SharedItems = $resource(settings.apiHost + '/r/StockSharedItems', {}, {
    save: {isArray: true, method: 'POST'}
  });
  var SharedItemsPrice = $resource(settings.apiHost + '/r/StockSharedItems/SharedItemsPrice', {}, {
    patch: {isArray: true, method: 'PATCH'}
  });
  var StockSharing = $resource(settings.apiHost + '/r/StockSharing', {});

  /**
   * [get description]
   *
   * @memberof StockSharedItems
   * @param  {?} localStockItemId [description]
   * @return {?}                  [description]
   */
  function get(localStockItemId) {
    return SharedItems.query({stockItemId: localStockItemId});
  }

  /**
   * [getSharePlan description]
   *
   * @memberof StockSharedItems
   * @param  {?} localStockItemIds [description]
   * @param  {?} targetCompanyId   [description]
   * @return {?}                   [description]
   */
  function getSharePlan(localStockItemIds, targetCompanyId) {
    return SharedItems.save({targetCompanyId: targetCompanyId}, localStockItemIds).$promise;
  }

  /**
   * [executeSharePlan description]
   *
   * @memberof StockSharedItems
   * @param  {?} plan            [description]
   * @param  {?} targetCompanyId [description]
   * @return {?}                 [description]
   */
  function executeSharePlan(plan, targetCompanyId) {
    return StockSharing.save({targetCompanyId: targetCompanyId}, plan).$promise;
  }

  /**
   * [update description]
   *
   * @memberof StockSharedItems
   * @param  {?} sharedItem [description]
   * @return {?}            [description]
   */
  function update(sharedItem) {
    return SharedItems.update({stockItemId: sharedItem.sharedStockItemId}, sharedItem).$promise;
  }

  /**
   * [searchCompanyUnits description]
   *
   * @memberof StockSharedItems
   * @param  {?} companyId [description]
   * @param  {?} searchStr [description]
   * @return {?}           [description]
   */
  function searchCompanyUnits(companyId, searchStr) {
    var deferred = $q.defer();

    var config = {
      headers: {
        'x-loaded-company-id': companyId
      },
      params: {
        $filter: 'contains(Name, \'' + searchStr.replace(/\'/g, '\'\'') + '\')'
      }
    };

    $http.get(settings.apiHost + '/r/StockUnits', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * [searchCompanyItems description]
   *
   * @memberof StockSharedItems
   * @param  {?} companyId [description]
   * @param  {?} searchStr [description]
   * @return {?}           [description]
   */
  function searchCompanyItems(companyId, searchStr) {
    var deferred = $q.defer();

    var config = {
      headers: {
        'x-loaded-company-id': companyId
      },
      params: {
        $filter: 'contains(Name, \'' + searchStr.replace(/\'/g, '\'\'') + '\') and IsShared eq false'
      }
    };

    $http.get(settings.apiHost + '/r/StockItems', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * [searchCompanySuppliers description]
   *
   * @memberof StockSharedItems
   * @param  {?} companyId [description]
   * @param  {?} searchStr [description]
   * @return {?}           [description]
   */
  function searchCompanySuppliers(companyId, searchStr) {
    var deferred = $q.defer();

    var config = {
      headers: {
        'x-loaded-company-id': companyId
      },
      params: {
        $filter: 'contains(Name, \'' + searchStr.replace(/\'/g, '\'\'') + '\')'
      }
    };

    $http.get(settings.apiHost + '/r/StockSuppliers', config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * [patchCompanyItem description]
   *
   * @memberof StockSharedItems
   * @param  {?} id        [description]
   * @param  {?} field     [description]
   * @param  {?} value     [description]
   * @param  {?} companyId [description]
   * @return {?}           [description]
   */
  function patchCompanyItem(id, field, value, companyId) {
    var deferred = $q.defer();

    var config = {
      headers: {
        'x-loaded-company-id': companyId
      }
    };

    var data = [{op: 'replace', path: field, value: value}];

    $http.patch(settings.apiHost + '/r/StockItems/' + id, data, config)
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * [patch shared items price]
   *
   * @memberof SharedItemsPrice
   * @param  {?} sharedStockItemId [description]
   * @param  {?} globalPrice       [description]
   * @return {?}                   [description]
   */
  function patchSharedItemsPrice(sharedStockItemId, globalPrice) {
    return SharedItemsPrice.patch({stockItemId: sharedStockItemId, globalPrice: globalPrice}, {}).$promise;
  }

  return {
    get: get,
    getSharePlan: getSharePlan,
    executeSharePlan: executeSharePlan,
    update: update,
    searchCompanyUnits: searchCompanyUnits,
    searchCompanyItems: searchCompanyItems,
    searchCompanySuppliers: searchCompanySuppliers,
    patchCompanyItem: patchCompanyItem,
    patchSharedItemsPrice: patchSharedItemsPrice
  };
}]);
